import React, { Component } from "react";
import Spinner from "util/components/spinner";
import OverviewCard from "visual-components/analyticsDashboard/overviewCard/overviewCard";
import GraphEmptyState from "visual-components/util/graphs/empty-state";
import MultiLineChart from "visual-components/util/graphs/multi-line";

export default class CampaignOverview extends Component {
  state = {
    selectedTab: "campaignVisits",
  };

  toggleItem = (type) => {
    const { overviewSelection } = this.props;

    const hideMap = this.props[overviewSelection].hideMap;
    hideMap[type] = !hideMap[type];

    store.dispatch({
      model: "analyticsCampaign",
      type: "UPDATE_ATTR",
      data: {
        [overviewSelection]: {
          ...this.props[overviewSelection],
          hideMap: hideMap,
        },
      },
    });
  };

  switchTab = (tab) => {
    store.dispatch({
      type: "UPDATE_ATTR",
      model: "analyticsCampaign",
      data: {
        overviewSelection: tab,
      },
    });
  };

  render() {
    const {
      overviewSelection,
      overviewAggregates,
      started,
      // canViewSms,
      campaignSocialActionClicksByTitle: socialActionClicks,
      campaignCustomCTA,
    } = this.props;

    // Calculate social actions total from clicks + CTA
    const socialActionClicksTotal =
      socialActionClicks?.data?.reduce((sum, item) => sum + (item.clicks ?? 0), 0) ?? 0;
    const customCtaTotal =
      campaignCustomCTA?.data?.reduce((sum, item) => sum + (item.entries ?? 0), 0) ?? 0;
    const calculatedSocialActionsTotal = socialActionClicksTotal + customCtaTotal;

    const defaultOverviewAggregates = {
      campaignEntries: 0,
      campaignNTF: 0,
      campaignTotalSocialActions: 0,
      campaignPartnerSmsContribution: 0,
      campaignVisits: 0,
    };

    // Override the social actions aggregate with calculated total
    const adjustedAggregates = {
      ...overviewAggregates,
      campaignTotalSocialActions: calculatedSocialActionsTotal,
    };

    const selectedData = this.props[overviewSelection];

    const tabs = [
      {
        ref: "campaignVisits",
        title: "visits",
        tooltip:
          "The Total Visits metric shows the combined number of visits to the sweepstakes landing page from all participating brands.",
      },
      {
        ref: "campaignNTF",
        title: "NTF emails",
        tooltip:
          "The NTF (New to File) metric counts the new unique emails added to your brand's list. These are emails from people who entered this campaign but had not joined any previous campaigns you've participated in or hosted on Dojo.",
      },
      // ...(
      //   canViewSms
      //     ? ([{
      //       ref: 'campaignPartnerSmsContribution',
      //       title: 'sms signups',
      //     }])
      //     : []
      // ),
      {
        ref: "campaignTotalSocialActions",
        title: "social actions",
        tooltip:
          "The Social Actions metric shows the total clicks on all social actions (and any custom calls to action) on the popup that appears after people enter their email to join the sweepstakes.",
      },
    ];

    if (!selectedData) {
      return <Spinner />;
    }

    const hasData = ["campaignTotalSocialActions"].includes(overviewSelection)
      ? selectedData.items.some((el) => el.data.some((num) => num.y > 0))
      : true;

    return (
      <OverviewCard
        aggregates={started ? adjustedAggregates : defaultOverviewAggregates}
        selectedTab={overviewSelection}
        tabs={tabs}
        switchTab={this.switchTab}
      >
        {hasData ? (
          <MultiLineChart {...selectedData} selectedTab={overviewSelection} />
        ) : (
          <GraphEmptyState
            text={
              "Social Actions is a powerful feature reserved for Essential and Premium DojoMojo users."
            }
            learnMore={
              "https://help.dojomojo.com/hc/en-us/articles/230426167-Add-Partner-Social-Actions-"
            }
            bigCard
            bigText
          />
        )}
      </OverviewCard>
    );
  }
}
